module.exports = __webpack_public_path__ + "fonts/iconfont.bb45e4f3.ttf";